import React from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../state";
import TreeCard from "../../../../../atoms/ActiveLearning/TreeCard";
import SaveAnswerButton from "../../../../../atoms/ActiveLearning/SaveAnswerButton";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson4/Material/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson4/Material/Issue2";
import Issue3 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson4/Material/Issue3";
import styles from "../../ActiveLearningLesson.module.scss";

type Lesson4MaterialProps = {
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson4Material = (props: Lesson4MaterialProps) => {
  return (
    <>
      <div className={styles.section}>
        <div className={styles.review}>
          <p className={styles.title}>前回の振り返り</p>
          <div className={styles.tree}>
            <TreeCard title={"問い"} text={"回答データがありません。"} />
            <ul className={styles.branchList}>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>問題</span>
                </div>
                <ul className={styles.answerList}>
                  <li className={clsx(styles.answer, styles.single)}>
                    回答データがありません。
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.section}>
        <Issue1 issue={props.findIssue && props.findIssue(1)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue2 issue={props.findIssue && props.findIssue(2)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue3 issue={props.findIssue && props.findIssue(3)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
    </>
  );
};
export default Lesson4Material;
